import React from 'react';
import unpick from '../../../utilities/unpick';

const FileUpload = (props) => {
  const { accept = ['image/*', '.pdf'], innerRef, className, multiple, maxFiles } = props;
  const p = unpick(props, [
    'isValid',
    'value',
    'className',
    'maxFileSize',
    'maxFiles',
    'accept',
    'innerRef',
    'multiple',
  ]);

  return (
    <label htmlFor="file-upload" className={className}>
      <input
        id="file-upload"
        type="file"
        accept={accept.join(',')}
        multiple={multiple || !!maxFiles}
        {...p}
        ref={innerRef}
      />
    </label>
  );
};

export default FileUpload;
